import {clsx} from 'clsx'

import {Link} from '@github-ui/react-router'
import styles from './SidebarListItem.module.css'

export interface SidebarListItemProps {
  href: string
  text: string
  isSelected?: boolean
  trailingAction?: React.ReactNode
  trailingVisual?: React.ReactNode
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  className?: string
  leadingVisual?: React.ComponentType
  secondaryText?: string | React.ReactNode
  reloadDocument?: boolean
  linkRef?: React.RefObject<HTMLAnchorElement | null>
}

export function SidebarListItem({
  href,
  text,
  isSelected,
  trailingAction,
  trailingVisual,
  onClick,
  className,
  leadingVisual: LeadingVisual,
  secondaryText,
  reloadDocument = false,
  linkRef,
}: SidebarListItemProps) {
  const hasSecondaryText = Boolean(secondaryText)
  const isNonInteractive = href === ''

  const content = (
    <div className={styles.content}>
      <div className={styles.topLine}>
        {LeadingVisual && (
          <span className={styles.statusIcon}>
            <LeadingVisual />
          </span>
        )}
        <span>{text}</span>
      </div>
      {secondaryText ? <p className={styles.secondaryText}>{secondaryText}</p> : null}
    </div>
  )

  return (
    <li className={clsx(styles.item, className)} data-selected={isSelected}>
      {isNonInteractive ? (
        <div className={clsx(styles.link, {[styles.linkWithSecondaryText]: hasSecondaryText})}>{content}</div>
      ) : (
        <Link
          ref={linkRef}
          className={clsx(styles.link, {[styles.linkWithSecondaryText]: hasSecondaryText})}
          to={href}
          aria-current={isSelected ? 'page' : undefined}
          onClick={onClick}
          reloadDocument={reloadDocument}
        >
          {content}
        </Link>
      )}
      {trailingVisual ? <span className={styles.trailingVisual}>{trailingVisual}</span> : null}
      {trailingAction ? <span className={styles.trailingAction}>{trailingAction}</span> : null}
    </li>
  )
}
